module.exports = __webpack_public_path__ + "img/album14_35.abe1409f.jpg";